import { getToken, _fetch } from "./apiHelper";
import { protectedResources } from "../config/authConfig";
import { Workspace } from "../types/workspace";

import { Project } from "../types/project";


export const createOrganization = async (workspace : Workspace) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(workspace),
  };

  return _fetch(protectedResources.api.admin + "/create-organization", options);
};


export const deleteProject = async (project : Project) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "DELETE",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(protectedResources.api.admin, options);
};
